// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".WbQ58bj1AQPh-Z\\+FWRHh5A\\=\\={object-fit:cover;width:100%;height:100%}", "",{"version":3,"sources":["webpack://./src/content/styles/FullwidthImage.scss"],"names":[],"mappings":"AAAA,6BACE,gBAAA,CACA,UAAA,CACA,WAAA","sourcesContent":[".image {\n  object-fit: cover;\n  width: 100%;\n  height: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"image": "WbQ58bj1AQPh-Z+FWRHh5A=="
};
export default ___CSS_LOADER_EXPORT___;
